import React from 'react';
import classNames from 'classnames';

import { StatusBadge, statusBadgeTones } from '@components/StatusBadge';
import { Text, textVariantsEnum, fontWeightEnum } from '@components/Text';

import styles from './BillingCycleSelector.module.scss';

export const BillingCycleSelectorComponent = ({ options, value, onChange }) => (
  <div className={styles.selector}>
    {options.map((option) => {
      const isActive = option.value === value;
      return (
        <button
          key={option.value}
          type="button"
          className={classNames(styles.option, {
            [styles.option_active]: isActive,
          })}
          onClick={() => onChange(option.value)}
        >
          <div className={styles.optionTop}>
            <Text
              variant={textVariantsEnum.Text_sm}
              fontWeight={fontWeightEnum.Bold}
              color={isActive ? 'purple-700' : 'gray-900'}
            >
              {option.label}
            </Text>
            {option.discountPercent > 0 && (
              <StatusBadge
                label={`Save ${option.discountPercent}%`}
                tone={statusBadgeTones.success}
              />
            )}
          </div>
          <Text
            variant={textVariantsEnum.Text_xs}
            fontWeight={fontWeightEnum.Normal}
            color="gray-500"
          >
            {option.sublabel}
          </Text>
        </button>
      );
    })}
  </div>
);

BillingCycleSelectorComponent.displayName = 'BillingCycleSelector';
